/* Optional pointer depth. No canvas, asset downloads, scroll listeners or idle animation. */
(() => {
  const eligible = matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  const bound = new WeakSet();
  function setup(root = document) {
    root.querySelectorAll('.agw-arrivals__image-link').forEach(link => {
      if (bound.has(link)) return;
      bound.add(link);
      let frame = 0;
      let bounds;
      const reset = () => {
        cancelAnimationFrame(frame);
        frame = 0;
        bounds = null;
        ['--agw-tilt-x', '--agw-tilt-y', '--agw-light-x', '--agw-light-y'].forEach(name => link.style.removeProperty(name));
      };
      link.addEventListener('pointerenter', event => {
        if (eligible.matches && event.pointerType === 'mouse') bounds = link.getBoundingClientRect();
      });
      link.addEventListener('pointermove', event => {
        if (!eligible.matches || event.pointerType !== 'mouse' || !bounds) return;
        cancelAnimationFrame(frame);
        const x = Math.max(0, Math.min(1, (event.clientX - bounds.left) / bounds.width));
        const y = Math.max(0, Math.min(1, (event.clientY - bounds.top) / bounds.height));
        frame = requestAnimationFrame(() => {
          link.style.setProperty('--agw-tilt-x', `${(0.5 - y) * 3}deg`);
          link.style.setProperty('--agw-tilt-y', `${(x - 0.5) * 3}deg`);
          link.style.setProperty('--agw-light-x', `${x * 100}%`);
          link.style.setProperty('--agw-light-y', `${y * 100}%`);
          frame = 0;
        });
      }, { passive: true });
      link.addEventListener('pointerleave', reset);
      link.addEventListener('pointercancel', reset);
      eligible.addEventListener('change', reset);
    });
  }
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
